export default __webpack_public_path__ + "static/media/kliznekapije4.470d05f9.png";